<template>
  <div class="ov-page">
    <div class="ov-header">
      <div class="ov-note ov-note--info ov-header__note">
        <v-icon small>mdi-information-outline</v-icon>
        <span>{{ $t('attestationDocument.subtitle') }}</span>
      </div>
    </div>

    <div class="ov-card doc-card">
      <div class="ov-card__head">
        <div>
          <div class="ov-card__title">{{ $t('attestationDocument.importTitle') }}</div>
          <div class="ov-card__sub">{{ $t('attestationDocument.importSub') }}</div>
        </div>
        <span class="ov-badge ov-badge--navy ov-badge--plain">PDF</span>
      </div>

      <div class="ov-card__body">
        <div v-if="attestationTransportInBase64" class="ov-label">
          {{ $t('attestationDocument.previewTitle') }}
        </div>
        <div
          class="doc-drop"
          :class="{ 'doc-drop--filled': attestationTransportInBase64 }"
          @click="!attestationTransportInBase64 && $refs.fileInput.click()"
        >
          <button
            v-if="attestationTransportSelected || attestationTransportInBase64"
            type="button"
            class="ov-icon-btn ov-icon-btn--danger doc-drop__delete"
            @click.stop="clearFile"
          >
            <v-icon small>mdi-close</v-icon>
          </button>
          <iframe
            v-if="attestationTransportInBase64"
            class="doc-drop__pdf"
            :src="attestationTransportInBase64"
            :title="$t('attestationDocument.previewTitle')"
          ></iframe>
          <div v-else class="doc-drop__placeholder">
            <v-icon size="32">mdi-file-pdf-box</v-icon>
            <span>{{ $t('attestationDocument.clickToSelect') }}</span>
            <small>{{ $t('attestationDocument.sizeHint') }}</small>
          </div>
        </div>
        <div v-if="attestationTransportSelected" class="ov-hint doc-drop__name">
          {{ attestationTransportSelected.name }} · {{ (attestationTransportSelected.size / 1024).toFixed(1) }} Ko
        </div>
        <div v-else-if="attestationTransportInBase64" class="ov-hint">
          {{ $t('attestationDocument.previewSub') }}
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="application/pdf"
          style="display: none"
          @click="$event.target.value = ''"
          @change="attestationTransportSelected = $event.target.files[0] || null; convertirEnBase64(attestationTransportSelected)"
        />
      </div>

      <div class="ov-card__foot">
        <button
          v-if="attestationTransportSelected"
          type="button"
          class="ov-btn ov-btn--secondary"
          @click="clearFile"
        >
          <v-icon small>mdi-refresh</v-icon>
          {{ $t('attestationDocument.change') }}
        </button>
        <button
          type="button"
          class="ov-btn ov-btn--primary"
          :disabled="!attestationTransportSelected || !attestationTransportInBase64"
          @click="sendAttestationTransport"
        >
          <v-icon small>mdi-content-save</v-icon>
          {{ $t('attestationDocument.save') }}
        </button>
      </div>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
    <v-alert class="myalert alert-success" type="success" width="350px" dismissible>{{ successMsg }}</v-alert>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  API_SEND_DOCUMENTS,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import axios from "axios";
import { showErrorMessage, showSuccessMessage } from "../messages/messageProcess";
export default {
  name: "DocumentAttestationTransport",

  data() {
    return {
      errorMsg: null,
      successMsg: null,
      overlay: false,

      attestationTransportSelected: null,
      attestationTransportInBase64: "",
      pdfContent: null,

      documentToSend: {
        datas: [],
      },

      attestationTransportDocumentModel: {
        compagnieTransportRaisonSociale: null,
        typeDocument: null,
        content: null,
        typeMime: null,
      },
    };
  },

  methods: {
    clearFile() {
      this.attestationTransportSelected = null;
      this.attestationTransportInBase64 = "";
    },

    convertirEnBase64(file) {
      // Vidé pendant la lecture : « Enregistrer » reste désactivé tant que le fichier n'est pas entièrement lu
      this.attestationTransportInBase64 = "";
      if (!file) return;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.attestationTransportInBase64 = e.target.result;
      };
    },

    // ENVOYER DOCUMENT DE TRANSPORT
    async sendAttestationTransport() {
      this.overlay = true;
      this.attestationTransportDocumentModel.compagnieTransportRaisonSociale =
        this.$store.state.userAuthentified.compagnieTransportRaisonSociale;
      this.attestationTransportDocumentModel.typeDocument =
        "ATTESTATION_TRANSPORT";
      this.attestationTransportDocumentModel.content =
        this.attestationTransportInBase64.split(",")[1];
      this.attestationTransportDocumentModel.typeMime = "FORMAT_PDF";
      this.documentToSend.datas.push(this.attestationTransportDocumentModel);
      await axios
        .post(API_SEND_DOCUMENTS, this.documentToSend, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code == 800) {
              this.successMsg = response.data.status.message;
              showSuccessMessage()
              this.documentToSend.datas = [];
              this.attestationTransportSelected = null;
            } else {
              this.errorMsg = response.data.status.message;
              showErrorMessage()
              this.documentToSend.datas = [];
              this.attestationTransportSelected = null;
            }
          } else {
            this.errorMsg = "Impossible de soumettre le document";
            showErrorMessage()
            this.documentToSend.datas = [];
            this.attestationTransportSelected = null;
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage()
          this.documentToSend.datas = [];
          this.attestationTransportSelected = null;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.doc-card {
  max-width: 820px;
}

/* DÉPÔT DU DOCUMENT */
.doc-drop {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 190px;
  overflow: hidden;
  border: 1px dashed rgba(15, 23, 42, 0.18);
  border-radius: 12px;
  background: $ov-soft;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: $ov-green;
    background: rgba(21, 158, 114, 0.04);
  }

  &--filled {
    border-style: solid;
    border-color: $ov-line;
    background: #ffffff;
    cursor: default;
  }
}

.doc-drop__delete {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

.doc-drop__pdf {
  display: block;
  width: 100%;
  height: 480px;
  border: 0;
}

.doc-drop__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: $ov-muted;
  pointer-events: none;
  user-select: none;

  small {
    font-size: 12px;
    font-weight: 500;
    color: $ov-subtle;
  }

  .v-icon {
    color: $ov-subtle !important;
  }
}

.doc-drop__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
